"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[4925],{

/***/ 24925:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./pages/questions/components/resource_limit_counter/index.js
var resource_limit_counter = __webpack_require__(86274);
// EXTERNAL MODULE: ./pages/questions/components/question_comments/cadeado.png
var cadeado = __webpack_require__(43966);
// EXTERNAL MODULE: ./pages/questions/components/question_comments/concursos.png
var concursos = __webpack_require__(31887);
// EXTERNAL MODULE: ./pages/questions/components/question_comments/index.scss
var question_comments = __webpack_require__(7420);
// EXTERNAL MODULE: ./pages/questions/components/question_comments/paywall.erb
var paywall = __webpack_require__(17426);
// EXTERNAL MODULE: ./components/freemium/block_message/index.js
var block_message = __webpack_require__(68862);
// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
// EXTERNAL MODULE: ./utils/modal_manager/index.js
var modal_manager = __webpack_require__(87322);
// EXTERNAL MODULE: ./pages/questions/components/question_comment/block.png
var block = __webpack_require__(69249);
// EXTERNAL MODULE: ./pages/questions/components/question_comment/block_mobile.png
var block_mobile = __webpack_require__(8714);
// EXTERNAL MODULE: ./pages/questions/components/question_comment/index.scss
var question_comment = __webpack_require__(61729);
// EXTERNAL MODULE: ./components/user/avatar/index.js
var avatar = __webpack_require__(39125);
// EXTERNAL MODULE: ./components/modals/abuse_report_modal/index.js
var abuse_report_modal = __webpack_require__(3749);
// EXTERNAL MODULE: ./pages/questions/components/comment_replies/index.scss
var comment_replies = __webpack_require__(95045);
// EXTERNAL MODULE: ./utils/event_manager/index.js
var event_manager = __webpack_require__(69705);
// EXTERNAL MODULE: ./utils/api_error_handler/index.js
var api_error_handler = __webpack_require__(98973);
// EXTERNAL MODULE: ./pages/questions/components/comment_replies/comment_replies_editor/index.scss
var comment_replies_editor = __webpack_require__(2968);
;// CONCATENATED MODULE: ./pages/questions/components/comment_replies/comment_replies_editor/index.js



class QuestionRepliesEditor {
    instantiateQuill() {
        const $editor = window.jQuery(`#q-editor-reply-${this.commentId}`, this.$context);
        if (!$editor.length || $editor.hasClass('ql-container')) {
            return;
        }
        this.editor = new Quill(`#q-editor-reply-${this.commentId}`, {
            modules: {
                toolbar: [
                    [
                        'bold',
                        'italic',
                        'underline'
                    ],
                    [
                        {
                            color: [
                                false,
                                'red',
                                'green',
                                'blue'
                            ]
                        }
                    ]
                ]
            },
            placeholder: 'Responder...',
            theme: 'snow'
        });
        this.$questionCommentArea = window.jQuery('.ql-editor', this.$context);
        this._bindSend();
        this.listenToCommentEditEvent();
    }
    _bindSend() {
        this.$sendButton.on('click', (e)=>{
            e.preventDefault();
            if (this._validateCommentArea()) {
                event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentId}.create`, {
                    commentHTML: this.$questionCommentArea.html()
                });
            }
        });
    }
    listenToCommentEditEvent() {
        event_manager/* EventManager.subscribe */.Q.subscribe(`commentReply.${this.commentId}.populateEditor`, this.updateEditor.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`commentReply.${this.commentId}.failed`, this.updateEditor.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`commentReply.${this.commentId}.saved`, this.clearEditor.bind(this));
    }
    updateEditor(event, data) {
        this.editor.clipboard.dangerouslyPasteHTML(data.commentHTML);
        this.activateEditMode(data.replyId);
        window.jQuery('html, body').animate({
            scrolltop: this.$context.offset().top - 40
        }, 800);
    }
    clearEditor() {
        this.editor.setText('');
    }
    activateEditMode(replyId) {
        this.$sendButton.off('click').on('click', ()=>{
            if (this._validateCommentArea()) {
                event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentId}.update`, {
                    commentHTML: this.$questionCommentArea.html(),
                    replyId
                });
                this.activateCreateMode();
                this.clearEditor();
            }
        });
    }
    activateCreateMode() {
        this.$sendButton.off('click').on('click', (e)=>{
            e.preventDefault();
            if (this._validateCommentArea()) {
                event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentId}.create`, {
                    commentHTML: this.$questionCommentArea.html()
                });
            }
        });
    }
    _validateCommentArea() {
        if (window.jQuery.trim(this.$questionCommentArea.text()).length > 0) {
            return true;
        } else {
            toastr.warning('Seu comentário não pode ser vazio.');
            return false;
        }
    }
    static createAndRender(commentId, segmentId, commentHTML) {
        return new Promise((resolve, reject)=>{
            Thor.Commentary.create_and_render({
                question_id: commentId
            }, {
                data: {
                    text: commentHTML,
                    resource_id: commentId,
                    segment_id: segmentId,
                    source_project: 1,
                    component_name: 'questions/comment_replies/item'
                }
            }).then((html)=>resolve(html)).catch(({ response })=>{
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível criar seu comentário nesse momento!', response);
                reject(response);
            });
        });
    }
    static updateAndRender(commentId, replyId, commentHTML) {
        return new Promise((resolve, reject)=>{
            Thor.Commentary.update_and_render({
                question_id: commentId,
                id: replyId
            }, {
                data: {
                    text: commentHTML,
                    component_name: 'questions/comment_replies/item'
                }
            }).then((html)=>resolve(html)).catch(({ response })=>{
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível editar seu comentário nesse momento!', response);
                reject(response);
            });
        });
    }
    constructor(context){
        vendorManager.ensure('quill', ()=>{
            this.$context = window.jQuery(context);
            this.commentId = this.$context.data().commentId;
            this.segmentId = this.$context.data().segmentId;
            this.questionCommentArea = false;
            this.$sendButton = window.jQuery('.js-send-comment-btn', this.$context);
            this.$editButton = window.jQuery('.js-edit-replies-btn', this.$context);
            this.instantiateQuill();
            this.activateCreateMode();
        });
    }
}


// EXTERNAL MODULE: ./pages/questions/components/comment_replies/item/index.scss
var item = __webpack_require__(34237);
;// CONCATENATED MODULE: ./pages/questions/components/comment_replies/item/index.js


class Item {
    _bindSend() {
        this.$btnDelete.on('click', (e)=>{
            e.preventDefault();
            event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentId}.delete`, {
                replyId: this.replyId
            });
        });
    }
    _bindEdit() {
        this.$btnEdit.off('click').on('click', (e)=>{
            e.preventDefault();
            const commentHTML = window.jQuery('.js-question-reply-text', this.$context).html();
            event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentId}.populateEditor`, {
                commentHTML,
                replyId: this.replyId
            });
        });
    }
    constructor(context){
        this.$context = window.jQuery(context);
        this.replyId = this.$context.data().replyId;
        this.commentId = this.$context.data().commentId;
        this.$btnDelete = window.jQuery('.js-delete-replies-btn', this.$context);
        this.$btnEdit = window.jQuery('.js-edit-replies-btn', this.$context);
        this._bindSend();
        this._bindEdit();
    }
}


;// CONCATENATED MODULE: ./pages/questions/components/comment_replies/index.js






class CommentReplies {
    _subscribe() {
        event_manager/* EventManager.subscribe */.Q.subscribe(`commentReply.${this.commentId}.create`, this.createReply.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`commentReply.${this.commentId}.update`, this.updateComment.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`commentReply.${this.commentId}.delete`, this.deleteComment.bind(this));
    }
    _bindReplies() {
        window.jQuery('.js-reply-info', this._getRepliesListElement()).each((i, questionComment)=>{
            if (!questionComment.questionCommentInstance) {
                questionComment.questionCommentInstance = new Item(questionComment);
            }
        });
    }
    _getRepliesListElement() {
        return window.jQuery('.js-question-replies', this.$context);
    }
    createReply(event, data) {
        QuestionRepliesEditor.createAndRender(this.commentId, 22, data.commentHTML).then((response)=>{
            const $questionCommentList = window.jQuery('.q-question-replies', this.$context);
            $questionCommentList.append(response.data);
            this._bindReplies();
            window.jQuery('html, body').animate({
                scrollTop: $questionCommentList.offset().top - 40
            }, 700);
            event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentId}.saved`);
            toastr.success('Comentário enviado com sucesso');
        }).catch(()=>{
            event_manager/* EventManager.publish */.Q.publish(`commentReply.${this.commentReply}.failed`, {
                commentHTML: data.commentHTML
            });
        });
    }
    updateComment(event, data) {
        QuestionRepliesEditor.updateAndRender(this.commentId, data.replyId, data.commentHTML).then((response)=>{
            const html = response.data;
            window.editedInfo = html;
            const $questionCommentList = window.jQuery('.js-question-replies', this.$context);
            const content = window.jQuery(html).find('.js-question-reply-text').html();
            const $questionComment = window.jQuery(`#question-reply-${data.replyId}`, this.$context);
            $questionComment.find('.js-question-reply-text').html(content);
            event_manager/* EventManager.publish */.Q.publish(`commentReply.${data.replyId}.saved`);
            window.jQuery('html, body').animate({
                scrollTop: $questionCommentList.offset().top - 40
            }, 700);
            toastr.success('Comentário atualizado com sucesso');
        }).catch(()=>{
            event_manager/* EventManager.publish */.Q.publish(`commentReply.${data.replyId}.failed`, {
                commentHTML: data.commentHTML
            });
        });
    }
    deleteComment(event, data) {
        modal_manager/* default.open */.Z.open('#js-confirm-delete-comment-modal', (res)=>{
            if (res === true) {
                this.delete(data.replyId).then(()=>{
                    const $questionComment = window.jQuery(`#question-reply-${data.replyId}`, this.$context);
                    $questionComment.fadeOut();
                    toastr.success('Comentário excluido com sucesso');
                }).catch(()=>{
                    toastr.error('Ops! Não foi possível excluir o comentário nesse momento!');
                });
            }
        });
    }
    delete(replyId) {
        return new Promise((resolve, reject)=>{
            Thor.Commentary.delete({
                question_id: this.commentId,
                id: replyId
            }, {}).then((html)=>resolve(html)).catch(({ response })=>{
                var _response_responseJSON_errors, _response_responseJSON;
                const defaultMessage = 'Ops! Não foi possivel excluir o seu comentário nesse momento!';
                const errors = (response == null ? void 0 : (_response_responseJSON = response.responseJSON) == null ? void 0 : (_response_responseJSON_errors = _response_responseJSON.errors) == null ? void 0 : _response_responseJSON_errors.text) || [
                    defaultMessage
                ];
                (0,api_error_handler/* handleApiError */.z)(defaultMessage, response);
                reject(errors);
            });
        });
    }
    constructor(context){
        this.$context = window.jQuery(context);
        this.commentId = this.$context.data().commentId;
        this._subscribe();
        this._bindReplies();
    }
}


// EXTERNAL MODULE: ./pages/questions/components/question_likes/index.js
var question_likes = __webpack_require__(33516);
// EXTERNAL MODULE: ./utils/error_interpreter/index.js
var error_interpreter = __webpack_require__(94256);
;// CONCATENATED MODULE: ./pages/questions/components/question_comment/index.js










class QuestionComment {
    bindAll() {
        this._bindReply();
        this._bindReportAbuse();
        this._bindDeleteComment();
        this._bindEditComment();
        this._bindCollapseIcon();
        this._bindChangeCommentType();
    }
    _bindReportAbuse() {
        if (this.isBlurred) {
            return;
        }
        this.$reportButton.off('click.question_comment_report_abuse').on('click.question_comment_report_abuse', ()=>this.reportAbuse());
    }
    _bindChangeCommentType() {
        if (this.isBlurred) {
            return;
        }
        this.$changeCommentTypeButton.off('click.question_comment_recommendation').on('click.question_comment_recommendation', (e)=>this.changeCommentType(e));
    }
    _bindDeleteComment() {
        this.$deleteButton.off('click.question_comment_delete').on('click.question_comment_delete', ()=>{
            event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.delete`, {
                commentId: this.commentId
            });
        });
    }
    _bindEditComment() {
        this.$editButton.off('click.question_comment_edit').on('click.question_comment_edit', ()=>{
            const commentHTML = window.jQuery('.js-question-comment-text', this.$context).html();
            const eventName = `questionComment.${this.questionId}.populateEditor`;
            event_manager/* EventManager.publish */.Q.publish(eventName, {
                commentHTML,
                commentId: this.commentId
            });
        });
    }
    _bindReply() {
        if (this.isBlurred) {
            return;
        }
        this.$replyButton.on('click', (e)=>{
            e.preventDefault();
            const $reply = window.jQuery('.js-question-reply', this.$context);
            $reply.toggleClass('hidden');
            new QuestionRepliesEditor(this.$context);
        });
    }
    _bindCollapseIcon() {
        const $button = window.jQuery('.js-collapsible', this.$context);
        $button.on('click', (e)=>{
            const $current = window.jQuery(e.currentTarget).find('.q-icon-angle-down');
            $current.toggleClass('q-icon-angle-up');
        });
    }
    static createAndRender(questionId, segmentId, commentHTML) {
        return new Promise((resolve, reject)=>{
            Thor.Commentary.create_and_render({
                question_id: questionId
            }, {
                data: {
                    text: commentHTML,
                    resource_id: questionId,
                    segment_id: segmentId,
                    source_project: 1,
                    component_name: 'questions/question_comment'
                }
            }).then((html)=>resolve(html)).catch(({ response })=>{
                (0,error_interpreter/* errorInterpreter */.u)({
                    message: 'Ops! Não foi possível criar seu comentário nesse momento!',
                    response
                });
                reject(response);
            });
        });
    }
    static updateAndRender(questionId, commentId, commentHTML) {
        return new Promise((resolve, reject)=>{
            Thor.Commentary.update_and_render({
                question_id: questionId,
                id: commentId
            }, {
                data: {
                    text: commentHTML,
                    component_name: 'questions/question_comment'
                }
            }).then((html)=>resolve(html)).catch(({ response })=>{
                (0,error_interpreter/* errorInterpreter */.u)({
                    message: 'Ops! Não foi possível atualizar seu comentário nesse momento!',
                    response
                });
                reject(response);
            });
        });
    }
    static delete(questionId, commentId) {
        return new Promise((resolve, reject)=>{
            Thor.Commentary.delete({
                question_id: questionId,
                id: commentId
            }, {}).then((html)=>resolve(html)).catch(({ response })=>{
                (0,error_interpreter/* errorInterpreter */.u)({
                    message: 'Ops! Não foi possivel excluir o seu comentário nesse momento!',
                    response
                });
                reject(response);
            });
        });
    }
    reportAbuse() {
        abuse_report_modal/* default.openForQuestionsCommentary */.Z.openForQuestionsCommentary({
            commentId: this.commentId,
            questionId: this.questionId
        });
    }
    changeCommentType(e) {
        const data = e.currentTarget.dataset;
        const commentary_id = parseInt(data.id);
        const segment_id = parseInt(data.segmentId);
        Thor.Commentary.recommend({}, {
            data: {
                commentary_id,
                segment_id
            }
        }).then(()=>{
            event_manager/* EventManager.publish */.Q.publish(`questionBelt.${this.questionId}.comments.updateTotal`, -1);
            event_manager/* EventManager.publish */.Q.publish(`questionBelt.${this.questionId}.commentsTeachers.updateTotal`, 1);
            window.QuestionBelt.loadTab(this.$context.parents('.q-question-belt'), 'question_comments', true);
        }).catch(({ response })=>{
            (0,error_interpreter/* errorInterpreter */.u)({
                response
            });
        });
    }
    constructor(context){
        this.$context = window.jQuery(context);
        this.isBlurred = this.$context.data().isBlurred;
        this.questionId = this.$context.data().questionId;
        this.commentId = this.$context.data().commentId;
        this.$reportButton = window.jQuery('.js-report-abuse-btn', this.$context);
        this.$replyButton = window.jQuery('.js-reply-comment-btn', this.$context);
        this.$deleteButton = window.jQuery('.js-delete-comment-btn', this.$context);
        this.$editButton = window.jQuery('.js-edit-comment-btn', this.$context);
        this.$changeCommentTypeButton = window.jQuery('.js-change-comment-type-to-teacher', this.$context);
        new CommentReplies(this.$context);
        if (!this.isBlurred) {
            new question_likes/* default */.Z(this.$context);
        }
        this.bindAll();
    }
}


// EXTERNAL MODULE: ./pages/questions/components/question_comment_editor/index.scss
var question_comment_editor = __webpack_require__(72613);
;// CONCATENATED MODULE: ./pages/questions/components/question_comment_editor/index.js



class QuestionCommentEditor {
    instantiateQuill() {
        const $editor = window.jQuery(`#editor-target-${this.questionId}`, this.$context);
        // if quill was already started here we can skip the init function
        if (!$editor.length || $editor.hasClass('ql-container')) {
            return;
        }
        this.editor = new Quill($editor.get(0), {
            modules: {
                toolbar: [
                    [
                        'bold',
                        'italic',
                        'underline'
                    ],
                    [
                        {
                            color: [
                                true,
                                'red',
                                'green',
                                'blue'
                            ]
                        }
                    ],
                    [
                        {
                            list: 'ordered'
                        },
                        {
                            list: 'bullet'
                        }
                    ]
                ]
            },
            placeholder: 'Escreva o seu comentário',
            theme: 'snow'
        });
        this.$questionCommentArea = window.jQuery('.ql-editor', this.$context);
        this.instantiateProgressBar();
        this.listenToCommentEditEvent();
        this.bindAll();
    }
    instantiateProgressBar() {
        const radius = this.progressCircle.getAttribute('r');
        const pcClass = 'q-progress-circle';
        this.progressCircle.style.strokeDasharray = 2 * Math.PI * radius;
        this.progressCircle.style.strokeDashoffset = 2 * Math.PI * radius;
        this.editor.on('text-change', ()=>{
            const currentLength = this.editor.getLength();
            const ratio = currentLength / this.maximumCharactersLength;
            if (ratio < 0.9) {
                this.progressCircle.classList.remove(`${pcClass}--warn`, `${pcClass}--danger`, `${pcClass}--pulse`);
                this.progressCircle.classList.add(`${pcClass}--safe`);
                this.$sendButton.get(0).disabled = false;
                this.charCounter.classList.remove(`${pcClass}--error`);
                this.charCounter.innerText = '';
            } else if (1 >= ratio && ratio >= 0.9) {
                this.progressCircle.classList.remove(`${pcClass}--safe`, `${pcClass}--danger`, `${pcClass}--pulse`);
                this.progressCircle.classList.add(`${pcClass}--warn`);
                this.charCounter.classList.remove(`${pcClass}--error`);
                this.charCounter.innerText = this.maximumCharactersLength - currentLength;
                this.$sendButton.get(0).disabled = false;
            } else {
                this.progressCircle.classList.remove(`${pcClass}--safe`, `${pcClass}--warn`);
                this.progressCircle.classList.add(`${pcClass}--danger`, `${pcClass}--pulse`);
                this.charCounter.classList.add('error');
                this.charCounter.innerText = this.maximumCharactersLength - currentLength;
                this.$sendButton.get(0).disabled = true;
            }
            this.progressCircle.style.strokeDashoffset = ratio >= 1 ? 0 : 2 * Math.PI * radius - ratio * (2 * Math.PI * radius);
        });
    }
    bindAll() {
        this.activateCreateMode();
        this.bindCancelButton();
        this.attachEvent();
    }
    bindCancelButton() {
        this.$cancelButton.off('click').on('click', ()=>{
            this.editor.setText('');
            this.$cancelButton.addClass('hidden');
            this.activateCreateMode();
        });
    }
    listenToCommentEditEvent() {
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionComment.${this.questionId}.populateEditor`, this.updateEditor.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionComment.${this.questionId}.failed`, this.updateEditor.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionComment.${this.questionId}.saved`, this.clearEditor.bind(this));
    }
    updateEditor(event, data) {
        this.$cancelButton.removeClass('hidden');
        this.editor.clipboard.dangerouslyPasteHTML(data.commentHTML);
        const { top, left } = this.$context.offset();
        if (top === 0 && left === 0) {
            return false;
        }
        this.activateEditMode(data.commentId);
        window.jQuery('html, body').animate({
            scrollTop: top - 40
        }, 800);
    }
    clearEditor() {
        this.editor.setText('');
    }
    activateEditMode(commentId) {
        this.$sendButton.text('Editar');
        this.$sendButton.off('click').on('click', ()=>{
            if (this._validateCommentArea()) {
                event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.update`, {
                    commentHTML: this.$questionCommentArea.html(),
                    commentId: commentId
                });
                this.$cancelButton.addClass('hidden');
                this.activateCreateMode();
            }
        });
    }
    activateCreateMode() {
        this.$sendButton.text('Responder');
        this.$sendButton.off('click').on('click', (e)=>{
            e.preventDefault();
            if (this._validateCommentArea()) {
                event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.create`, {
                    commentHTML: this.$questionCommentArea.html()
                });
                event_manager/* EventManager.publish */.Q.publish('followOnComment', this.questionId);
            }
        });
    }
    _validateCommentArea() {
        if (window.jQuery.trim(this.$questionCommentArea.text()).length > 0) {
            return true;
        } else {
            toastr.warning('Seu comentário não pode ser vazio.');
            return false;
        }
    }
    attachEvent() {
        this.$sendButton.on('click', (e)=>{
            e.preventDefault();
            if (this._validateCommentArea()) {
                UserTracker.emit('event', {
                    eventName: 'question commentary created',
                    data: {
                        reply_enabled: this.replyEnabled
                    }
                });
            }
        });
    }
    static createAndRender(questionId, segmentId, commentHTML) {
        return new Promise((resolve, reject)=>{
            QuestionComment.createAndRender(questionId, segmentId, commentHTML).then((html)=>{
                resolve(html);
            }).catch((err)=>{
                reject(err);
            });
        });
    }
    static updateAndRender(questionId, commentId, commentHTML) {
        return new Promise((resolve, reject)=>{
            QuestionComment.updateAndRender(questionId, commentId, commentHTML).then((html)=>{
                resolve(html);
            }).catch((errors)=>{
                reject(errors);
            });
        });
    }
    constructor(context){
        vendorManager.ensure('quill', ()=>{
            this.$context = window.jQuery(context);
            this.questionId = this.$context.data().questionId;
            this.replyEnabled = this.$context.data().replyEnabled;
            this.maximumCharactersLength = this.$context.data().maximumCharactersLength;
            this.$cancelButton = window.jQuery('.js-cancel-comment-btn', this.$context);
            this.$sendButton = window.jQuery('.js-send-comment-btn', this.$context);
            this.$questionCommentArea = false;
            this.progressCircle = window.jQuery('.js-progress-circle', this.context).get(0);
            this.charCounter = window.jQuery('.js-char-counter', this.context).get(0);
            this.instantiateQuill();
        });
    }
}


;// CONCATENATED MODULE: ./pages/questions/components/question_comments/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}











class QuestionComments {
    _bindLoadMoreButton() {
        this.$context.off('click', '.js-load-more-btn').on('click', '.js-load-more-btn', (event)=>this.loadMoreComments(window.jQuery(event.currentTarget)));
    }
    _bindSortButton() {
        if (this.blurComments) {
            this.$context.on('click', '.js-order-by-btn', (event)=>event.preventDefault());
            return;
        }
        this.$context.off('click', '.js-order-by-btn').on('click', '.js-order-by-btn', (event)=>this.sort(window.jQuery(event.currentTarget)));
    }
    _bindComments() {
        window.jQuery('.js-question-comment', this._getCommentsListElement()).each((i, questionComment)=>{
            if (!questionComment.questionCommentInstance) {
                questionComment.questionCommentInstance = new QuestionComment(questionComment);
            }
        });
    }
    _bindCommentEditor() {
        const $editor = window.jQuery('.js-question-comment-editor', this.$context);
        $editor.length && new QuestionCommentEditor($editor);
    }
    _subscribe() {
        event_manager/* EventManager.unsubscribe */.Q.unsubscribe(`questionBelt.${this.questionId}`);
        event_manager/* EventManager.unsubscribe */.Q.unsubscribe(`questionComment.${this.questionId}.create`);
        event_manager/* EventManager.unsubscribe */.Q.unsubscribe(`questionComment.${this.questionId}.update`);
        event_manager/* EventManager.unsubscribe */.Q.unsubscribe(`questionComment.${this.questionId}.delete`);
        event_manager/* EventManager.unsubscribe */.Q.unsubscribe(`questionBelt.${this.questionId}.comments.updateTotal`);
        event_manager/* EventManager.unsubscribe */.Q.unsubscribe(`questionBelt.${this.questionId}.commentsTeachers.updateTotal`);
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionComment.${this.questionId}.create`, this.createComment.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionComment.${this.questionId}.update`, this.updateComment.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionComment.${this.questionId}.delete`, this.deleteComment.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionBelt.${this.questionId}.comments.updateTotal`, this.updateTotalCounter.bind(this));
        event_manager/* EventManager.subscribe */.Q.subscribe(`questionBelt.${this.questionId}.commentsTeachers.updateTotal`, this.updateTeachersCounter.bind(this));
    }
    _emitEvents(questionId) {
        if (this.$context.data('question-id') === questionId) {
            if (window.currentUser.subscriptionStatus === 'standard') {
                UserTracker.emit('event', {
                    eventName: 'student commentary viewed',
                    except: [
                        'user'
                    ]
                });
            }
        }
    }
    _getCommentsListElement() {
        return window.jQuery('.js-question-comments-list', this.$context);
    }
    _renderComments(html, replace = false) {
        const $html = window.jQuery(html);
        const data = $html.data();
        if (!data) {
            return;
        }
        const { nextPage, params: newParams } = data;
        const $commentsList = this._getCommentsListElement();
        $commentsList.data('params', newParams);
        $commentsList.data('next-page', nextPage);
        this._getCommentsListElement()[replace ? 'html' : 'append']($html.html());
        this._bindComments();
        (self || window).blazyInstance.revalidate();
    }
    createComment(event, data) {
        QuestionCommentEditor.createAndRender(this.questionId, this.segmentId, data.commentHTML).then((response)=>{
            const $questionCommentList = window.jQuery('.js-question-comments-list', this.$context);
            $questionCommentList.prepend(response.data);
            const newQuestionComment = window.jQuery('.js-question-comment', $questionCommentList).get(0);
            new QuestionComment(newQuestionComment);
            window.jQuery('html, body').animate({
                scrollTop: $questionCommentList.offset().top - 40
            }, 700);
            event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.saved`);
            event_manager/* EventManager.publish */.Q.publish(`questionBelt.${this.questionId}.comments.updateTotal`, 1);
            toastr.success('Comentário enviado com sucesso');
        }).catch(()=>{
            event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.failed`, {
                commentHTML: data.commentHTML
            });
        });
    }
    updateComment(event, data) {
        QuestionCommentEditor.updateAndRender(this.questionId, data.commentId, data.commentHTML).then((response)=>{
            const html = response.data;
            window.editedInfo = html;
            const content = window.jQuery(html).find('.js-question-comment-text').html();
            const $questionComment = window.jQuery(`#question-comment-${data.commentId}`, this.$context);
            $questionComment.find('.js-question-comment-text').html(content);
            event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.saved`);
            window.jQuery('html, body').animate({
                scrollTop: $questionComment.offset().top - 40
            }, 700);
            toastr.success('Comentário atualizado com sucesso');
        }).catch(()=>{
            event_manager/* EventManager.publish */.Q.publish(`questionComment.${this.questionId}.failed`, {
                commentHTML: data.commentHTML
            });
        });
    }
    deleteComment(event, data) {
        modal_manager/* default.open */.Z.open('#js-confirm-delete-comment-modal', (res)=>{
            if (res === true) {
                QuestionComment["delete"](this.questionId, data.commentId).then(()=>{
                    const $questionCommentList = window.jQuery('.js-question-comments-list', this.$context);
                    const $questionComment = window.jQuery(`#question-comment-${data.commentId}`, $questionCommentList);
                    $questionComment.fadeOut();
                    toastr.success('Comentário excluido com sucesso');
                    event_manager/* EventManager.publish */.Q.publish(`questionBelt.${this.questionId}.comments.updateTotal`, -1);
                }).catch(()=>{
                    toastr.error('Ops! Não foi possível excluir o comentário nesse momento!');
                });
            }
        });
    }
    updateCounts(selector, sum) {
        const isPlainValue = typeof sum === 'number';
        const sumNumber = isPlainValue ? sum : sum.value;
        const $counter = window.jQuery(selector, isPlainValue ? this.$context.parents('.q-question-belt') : sum.context);
        const newCount = parseInt($counter.html()) + sumNumber;
        $counter.html(newCount);
    }
    updateTotalCounter(event, sum) {
        this.updateCounts('.js-comments-count', sum);
    }
    updateTeachersCounter(event, sum) {
        this.updateCounts('.js-comments-teachers-count', sum);
    }
    loadComments(params, replace = true) {
        var _this = this;
        return _async_to_generator(function*() {
            const currentParams = _this._getCommentsListElement().data().params;
            try {
                const html = yield ajax_component_loader/* default.load */.Z.load({
                    component: 'questions/question_comments/comments_list',
                    type: 'page_component',
                    data: _extends({}, currentParams, params),
                    params: {
                        page: params.page || 1
                    }
                });
                _this._renderComments(html, replace);
            } catch (res) {
                if (res.status !== 401 && res.status !== 0) {
                    toastr.error('Ops! Não foi possível carregar os comentários!');
                }
            }
        })();
    }
    loadMoreComments($btn) {
        var _this = this;
        return _async_to_generator(function*() {
            const { orderBy } = $btn.data();
            const data = _this._getCommentsListElement().data();
            if (!(data == null ? void 0 : data.nextPage)) {
                return;
            }
            const { nextPage } = data;
            $btn.html('Carregando...');
            try {
                yield _this.loadComments({
                    page: nextPage,
                    orderBy: orderBy
                }, false);
                $btn.remove();
            } catch (ex) {
                $btn.html('Carregar mais');
            }
        })();
    }
    saveSortPreference(value) {
        return _async_to_generator(function*() {
            yield Thor.UserPreference.update({}, {
                data: {
                    user_preferences: {
                        questions_comments_order: value
                    }
                }
            });
        })();
    }
    sort($btn) {
        var _this = this;
        return _async_to_generator(function*() {
            const { orderBy } = $btn.data();
            try {
                yield _this.saveSortPreference(orderBy);
                yield _this.loadComments({
                    order_by: orderBy
                });
                window.jQuery('.js-order-by-btn', _this.$context).removeClass('active');
                $btn.addClass('active');
            } catch (ex) {
                toastr.error('Ops! Não foi possível ordenar os comentários!');
            }
        })();
    }
    constructor(context){
        this.$context = window.jQuery(context);
        const { questionId, segmentId, blurComments } = this.$context.data();
        this.questionId = questionId;
        this.segmentId = segmentId;
        this.blurComments = blurComments;
        this._bindCommentEditor();
        this._bindComments();
        this._bindLoadMoreButton();
        this._bindSortButton();
        this._subscribe();
        this.$context.parent().addClass('q-comments-initialized');
        event_manager/* EventManager.subscribe */.Q.subscribe('questionBelt.tabLoaded', (e, { $tabPane })=>{
            this.$context = window.jQuery('.js-question-comments', $tabPane);
            this._bindCommentEditor();
            this._bindComments();
            this._bindLoadMoreButton();
            this._bindSortButton();
            this._subscribe();
            this._emitEvents(questionId);
        });
    }
}
(function($1) {
    'use strict';
    $1(document).on('componentLoaded:questions/question_comments', (e, data)=>{
        const $questionCommentsEl = $1('.js-question-comments');
        if ($questionCommentsEl.length > 0) {
            const questionComments = $1('.js-question-comments', data.context).get(0);
            questionComments.questionCommentsInstance = new QuestionComments(questionComments);
        }
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_courses/index.js
var question_courses = __webpack_require__(48942);
// EXTERNAL MODULE: ./pages/questions/components/question_lessons/block.png
var question_lessons_block = __webpack_require__(24668);
// EXTERNAL MODULE: ./pages/questions/components/question_lessons/block_mobile.png
var question_lessons_block_mobile = __webpack_require__(28011);
// EXTERNAL MODULE: ./pages/questions/components/question_lessons/exclamacao.png
var exclamacao = __webpack_require__(15063);
// EXTERNAL MODULE: ./pages/questions/components/question_lessons/index.scss
var question_lessons = __webpack_require__(61270);
// EXTERNAL MODULE: ./components/empty_list_message/index.js
var empty_list_message = __webpack_require__(98389);
// EXTERNAL MODULE: ./styles/components/_responsive-embed.scss
var _responsive_embed = __webpack_require__(82688);
// EXTERNAL MODULE: ./utils/favorites_toggle/index.js
var favorites_toggle = __webpack_require__(48923);
// EXTERNAL MODULE: ./pages/lessons/components/lesson/index.js
var lesson = __webpack_require__(63468);
;// CONCATENATED MODULE: ./pages/questions/components/question_lessons/index.js








(function($) {
    'use strict';
    $(document).off('componentLoaded:questions/question_lessons').on('componentLoaded:questions/question_lessons', (e, data)=>{
        // Solução temporária
        const browserIsChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const collapsibleLessons = $('.js-lesson .js-collapsible-content');
        if (browserIsChrome) {
            collapsibleLessons.collapse('show');
        }
        $('.js-lesson', data.context).each((i, el)=>{
            el.lesson = new lesson/* default */.Z($(el));
        });
        const redirect_mesa = ()=>{
            const buttonElement = document.getElementById('link_go_to_ils_blocked_lessons');
            if (buttonElement) {
                const url = buttonElement.getAttribute('name');
                const question_id = buttonElement.getAttribute('question_id');
                const timestamp = new Date().getTime();
                let search = location.search.slice(1, location.search.length);
                if (!search) search += 'my_questions=all';
                const ils_complete_url = `${url}playground/questoes?lesson_question_id=${question_id}&${search}&timestamp=${timestamp}`;
                buttonElement.href = ils_complete_url;
            }
        };
        redirect_mesa();
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_maintenance/index.scss
var question_maintenance = __webpack_require__(72078);
// EXTERNAL MODULE: ./utils/disciplines_subjects_select/index.js
var disciplines_subjects_select = __webpack_require__(69033);
;// CONCATENATED MODULE: ./pages/questions/components/question_maintenance/index.js
function question_maintenance_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function question_maintenance_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                question_maintenance_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                question_maintenance_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



class QuestionMaintenanceTab {
    instantiateQuill() {
        const $questionId = window.jQuery('.q-maintence-quill-container', this.$context)[0].getAttribute('data-question-id');
        const quillContainer = window.jQuery(`#description-${$questionId}`, this.$context)[0];
        const verifyQuillExistence = window.jQuery(`#question-belt-${$questionId}-maintenance-tab`).find('.ql-toolbar').length !== 0;
        if (verifyQuillExistence) {
            return;
        }
        if (quillContainer) {
            this.uploadBucket = quillContainer.getAttribute('data-upload-bucket');
            this.uploadUrl = quillContainer.getAttribute('data-upload-url');
            this.editor = new Quill(quillContainer, {
                modules: {
                    toolbar: [
                        [
                            'bold',
                            'italic',
                            'underline'
                        ],
                        [
                            {
                                color: [
                                    true,
                                    'red',
                                    'green',
                                    'blue'
                                ]
                            }
                        ],
                        [
                            {
                                list: 'ordered'
                            },
                            {
                                list: 'bullet'
                            }
                        ],
                        [
                            'image'
                        ]
                    ]
                },
                placeholder: 'Escreva o seu comentário',
                theme: 'snow'
            });
            this.editor.getModule('toolbar').addHandler('image', ()=>{
                this._quillSelectLocalImage();
            });
        }
    }
    _quillSelectLocalImage() {
        const self = this;
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = /*#__PURE__*/ question_maintenance_async_to_generator(function*() {
            const file = input.files[0];
            if (/^image\//.test(file.type)) {
                yield self._quillAddImage(file);
            } else {
                toastr.error('Ops! Você só pode enviar imagens');
            }
        });
    }
    _quillAddImage(file) {
        var _this = this;
        return question_maintenance_async_to_generator(function*() {
            const self = _this;
            const randomId = new Date().getTime();
            const fileExtension = file.name.split('.').pop();
            const fileName = `odin/question_maintenance/${randomId}.${fileExtension}`;
            const fileUrl = `https://s3.amazonaws.com/${_this.uploadBucket}/${fileName}`;
            yield _this.uploadToS3(file, fileName, fileExtension);
            self._quillInsertToEditor(fileUrl);
        })();
    }
    _quillInsertToEditor(url) {
        const range = this.editor.getSelection();
        this.editor.insertEmbed(range.index, 'image', url);
    }
    getPresignedPostData(key, contentType) {
        var _this = this;
        return question_maintenance_async_to_generator(function*() {
            return yield window.jQuery.ajax({
                url: _this.uploadUrl,
                method: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify({
                    bucket: _this.uploadBucket,
                    key: key,
                    content_type: 'docx',
                    acl: 'public-read'
                })
            });
        })();
    }
    uploadToS3(file, key, contentType) {
        var _this = this;
        return question_maintenance_async_to_generator(function*() {
            const presignedPostData = yield _this.getPresignedPostData(key, contentType);
            const formData = new FormData();
            Object.keys(presignedPostData.fields).forEach((key)=>{
                formData.append(key, presignedPostData.fields[key]);
            });
            formData.append('file', file);
            yield window.jQuery.ajax({
                url: presignedPostData.url,
                type: 'POST',
                data: formData,
                cache: false,
                processData: false,
                contentType: false
            });
        })();
    }
    submit() {
        var _this = this;
        return question_maintenance_async_to_generator(function*() {
            try {
                const data = _this.$form.serializeObject();
                if (_this.editor) {
                    data.comment = _this.editor.root.innerHTML;
                }
                if (!data.subject_id && !data.comment) {
                    return;
                }
                _this.$form.addClass('q-loading');
                yield Thor.QuestionMaintenances.create({}, {
                    data
                });
                toastr.success('Operação realizada com sucesso!');
                _this.$form.clearForm();
                _this.$form.removeClass('q-loading');
            } catch (ex) {
                _this.$form.removeClass('q-loading');
                (0,api_error_handler/* handleApiError */.z)(null, ex.response || ex);
            }
        })();
    }
    bind() {
        this.$form.on('submit', (e)=>{
            e.preventDefault();
            this.submit();
        });
    }
    constructor($context){
        this.$context = $context;
        this.$form = window.jQuery('form', this.$context).ajaxForm();
        const $disciplineSelect = window.jQuery('#discipline_ids', this.$form);
        const $subjectSelect = window.jQuery('#subject_id', this.$form);
        disciplines_subjects_select/* default.init */.Z.init($disciplineSelect, $subjectSelect, {
            enableVisualTree: true
        });
        vendorManager.ensure('quill', ()=>{
            this.instantiateQuill();
        });
        this.bind();
    }
}
(function() {
    'use strict';
    window.jQuery(document).on('componentLoaded:questions/question_maintenance', (e, data)=>{
        new QuestionMaintenanceTab(data.context);
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_notebooks/index.scss
var question_notebooks = __webpack_require__(59320);
// EXTERNAL MODULE: ./components/select/index.js + 9 modules
var components_select = __webpack_require__(86325);
// EXTERNAL MODULE: ./utils/ajax_form/index.js
var ajax_form = __webpack_require__(13346);
;// CONCATENATED MODULE: ./pages/questions/components/question_notebooks/index.js





class QuestionNotebooksTab {
    reload() {
        window.QuestionBelt.loadTab(this.$questionBelt, 'question_notebooks', true);
    }
    createNotebook() {
        var _data_notebook, _data_notebook_name, _data_notebook1;
        const data = window.jQuery.extend(this.$createForm.serializeObject(), {
            source_project: 1
        });
        if (!((_data_notebook = data.notebook) == null ? void 0 : _data_notebook.name) || ((_data_notebook1 = data.notebook) == null ? void 0 : (_data_notebook_name = _data_notebook1.name) == null ? void 0 : _data_notebook_name.length) < 3) {
            return toastr.error('Por favor, informe um nome para o caderno.');
        }
        Thor.Notebook.create({}, {
            data: data
        }).then((result)=>{
            this.$createForm.clearForm().trigger('ajax:success');
            const { id, name } = result.notebook;
            window.UserTracker.emit('event', {
                eventName: 'notebook created',
                data: {
                    id: String(id),
                    name
                }
            });
            this.reload();
        }).catch(({ response })=>{
            const defaultMessage = 'Ops! Não foi possível criar o caderno nesse momento!';
            if (response.status === 422) {
                return response.json().then(({ errors })=>{
                    const errorMessages = Object.values(errors);
                    const message = errorMessages.length > 0 ? errorMessages[0][0] : defaultMessage;
                    toastr.error(message);
                });
            } else {
                (0,api_error_handler/* handleApiError */.z)(defaultMessage, response);
                this.$createForm.trigger('ajax:error', response);
            }
        });
    }
    chooseNotebooks() {
        const data = this.$chooseNotebooksForm.serializeObject();
        if (!data.notebook_id) {
            toastr.warning('Selecione o caderno para adicionar a questão ou crie um caderno novo.');
            return;
        }
        Thor.NotebookQuestion.create({}, {
            data: {
                notebook_id: data.notebook_id,
                question_id: this.questionId
            }
        }).then(()=>{
            this.$chooseNotebooksForm.trigger('ajax:success');
            this.reload();
        }).catch(({ response })=>{
            (0,error_interpreter/* errorInterpreter */.u)({
                message: 'Ops! Não foi possível adicionar a questão ao caderno nesse momento!',
                response
            });
            this.$chooseNotebooksForm.trigger('ajax:error');
        });
    }
    removeNotebook(notebookId, successMessage) {
        Thor.NotebookQuestion.delete({
            id: this.questionId
        }, {
            data: {
                notebooks_ids: notebookId
            }
        }).then(()=>{
            toastr.success(successMessage);
            this.reload();
        }).catch(({ response })=>{
            (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível remover o caderno nesse momento!', response);
        });
    }
    bind() {
        window.jQuery('.q-select-input', this.$context).qselect();
        this.$createForm.ajaxForm().lazyReady().on('submit', (e)=>{
            e.preventDefault();
            this.createNotebook();
            return false;
        });
        this.$chooseNotebooksForm.ajaxForm(false, false).lazyReady().on('submit', (e)=>{
            e.preventDefault();
            this.chooseNotebooks();
            return false;
        });
        window.jQuery('.js-btn-delete', this.$context).off('click').on('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.removeNotebook(window.jQuery(e.currentTarget).data('notebook-id'), window.jQuery(e.currentTarget).data('success-message'));
        });
    }
    constructor($context){
        this.$context = $context;
        this.$createForm = window.jQuery('.q-create-form', this.$context);
        this.$chooseNotebooksForm = window.jQuery('.q-choose-notebooks-form', this.$context);
        this.$questionBelt = this.$context.parents('.q-question-belt');
        this.questionId = this.$questionBelt.data('question-id');
        this.bind();
    }
}
(function($1) {
    'use strict';
    $1(document).off('componentLoaded:questions/question_notebooks').on('componentLoaded:questions/question_notebooks', (e, data)=>{
        new QuestionNotebooksTab(data.context);
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_notes/index.scss
var question_notes = __webpack_require__(75770);
// EXTERNAL MODULE: ./components/modals/basic_modal/index.js + 1 modules
var basic_modal = __webpack_require__(57039);
;// CONCATENATED MODULE: ./pages/questions/components/question_notes/index.js




class QuestionNotesTab {
    instantiateQuill() {
        const $editor = window.jQuery('#annotation-target', this.$context);
        // if quill was already started here we can skip the init function
        if (!$editor.length || $editor.hasClass('ql-container')) return;
        this.editor = new Quill($editor.get(0), {
            modules: {
                toolbar: [
                    [
                        'bold',
                        'italic',
                        'underline'
                    ],
                    [
                        {
                            color: [
                                false,
                                'red',
                                'green',
                                'blue'
                            ]
                        }
                    ]
                ]
            },
            placeholder: 'Você não possui anotações',
            theme: 'snow'
        });
        this.$questionAnnotationArea = window.jQuery('.ql-editor', this.$context);
        this.fillQuillContent();
    }
    fillQuillContent() {
        this.$quillContent = window.jQuery('.ql-editor', this.$context);
        this.$quillContent.html(window.jQuery('.js-annotation-value', this.$context).val());
    }
    bind() {
        const $createForm = window.jQuery('.js-create-note-form', this.$context);
        $createForm.ajaxForm(false).lazyReady().on('submit', (e)=>{
            e.preventDefault();
            if (this._validateAnnotationArea()) this.saveNote();
            return false;
        });
        window.jQuery('.js-delete-note-btn', this.$context).on('click', (e)=>this.deleteNote(e));
    }
    saveNote() {
        this.$questionAnnotationArea = window.jQuery('.ql-editor', this.$context).html();
        window.jQuery('.js-annotation-value').val(this.$questionAnnotationArea);
        const $createForm = window.jQuery('.js-create-note-form', this.$context);
        const data = $createForm.serializeObject();
        const method = $createForm.find('[name="_method"]').length ? 'update' : 'create';
        Thor.Annotation[method](data.annotation.id ? {
            id: data.annotation.id
        } : {}, {
            data: data
        }).then(()=>{
            $createForm.trigger('ajax:success');
            this.reload();
        }).catch(({ response })=>$createForm.trigger('ajax:error', response));
    }
    _validateAnnotationArea() {
        const hasBlankClass = window.jQuery('.ql-editor', this.$context).hasClass('ql-blank');
        const isWhiteSpace = window.jQuery('.ql-editor', this.$context).html() === '';
        if (!hasBlankClass && !isWhiteSpace) {
            return true;
        } else {
            toastr.warning('Seu comentário não pode ser vazio.');
            return false;
        }
    }
    deleteNote(e) {
        modal_manager/* default.open */.Z.open('#js-confirm-delete-note-modal', (res)=>{
            const annotationId = window.jQuery(e.currentTarget).data('annotation-id');
            if (res === true) Thor.Annotation.delete({
                id: annotationId
            }, {}).then(()=>{
                toastr.success('Anotação excluída com sucesso!');
                this.reload();
            }).catch(({ response })=>{
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível excluir sua anotação nesse momento!', response);
            });
        });
    }
    reload() {
        window.QuestionBelt.loadTab(this.$context.parents('.q-question-belt'), 'question_notes', true);
    }
    constructor($context){
        vendorManager.ensure('quill', ()=>{
            this.$context = $context;
            this.$questionAnnotationArea = false;
            this.instantiateQuill();
            this.bind();
        });
    }
}
(function() {
    'use strict';
    window.jQuery(document).on('componentLoaded:questions/question_notes', (e, data)=>{
        new QuestionNotesTab(data.context);
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_notify/index.scss
var question_notify = __webpack_require__(19252);
;// CONCATENATED MODULE: ./pages/questions/components/question_notify/index.js



class QuestionNotifyTab {
    createNotification() {
        const data = this.$createForm.serializeObject();
        Thor.QuestionError.create({}, {
            data
        }).then(()=>{
            this.$createForm.clearForm().trigger('ajax:success').clearForm();
        }).catch(({ response })=>{
            (0,error_interpreter/* errorInterpreter */.u)({
                message: 'Ops! Não foi possível criar a notificação nesse momento!',
                response
            });
            this.$createForm.trigger('ajax:error');
        });
    }
    bind() {
        this.$createForm.ajaxForm().lazyReady().on('submit', (e)=>{
            e.preventDefault();
            this.createNotification();
            return false;
        });
    }
    constructor($context){
        this.$context = $context;
        this.$createForm = window.jQuery('.q-create-form', this.$context);
        this.bind();
    }
}
(function() {
    'use strict';
    window.jQuery(document).off('componentLoaded:questions/question_notify').on('componentLoaded:questions/question_notify', (e, data)=>{
        window.jQuery('.q-select-input', data.context).qselect();
        new QuestionNotifyTab(data.context);
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_charts/index.scss
var question_charts = __webpack_require__(58755);
;// CONCATENATED MODULE: ./pages/questions/components/question_charts/index.js

(function($) {
    'use strict';
    function isValidToRender(el, data) {
        return el.length > 0 && Object.values(data).length > 0;
    }
    function incomePercentageChart(ctx) {
        const data = ctx.data();
        if (!isValidToRender(ctx, data)) {
            return false;
        }
        return new window.Chart(ctx, {
            type: 'pie',
            data: {
                counts: [
                    data.hitsCount,
                    data.mistakesCount
                ],
                mistakesCount: data.mistakesCount,
                datasets: [
                    {
                        label: '%',
                        data: [
                            data.hits,
                            data.mistakes
                        ],
                        backgroundColor: [
                            data.hitsColor,
                            data.mistakesColor
                        ]
                    }
                ],
                labels: [
                    'Acertos',
                    'Erros'
                ]
            },
            options: {
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, chartData)=>{
                            const i = tooltipItem.index;
                            return `${chartData.labels[i]}: ${chartData.counts[i]} | ${chartData.datasets[0].data[i]}%`;
                        }
                    }
                },
                cutoutPercentage: 50,
                title: {
                    display: true,
                    text: 'Percentual de Rendimento'
                }
            }
        });
    }
    function mostAnsweredAlternativesChart(ctx) {
        const data = ctx.data();
        if (!isValidToRender(ctx, data)) {
            return false;
        }
        new window.Chart(ctx, {
            type: 'bar',
            data: {
                counts: data.alternativesCount.split(', '),
                labels: data.options.split(','),
                datasets: [
                    {
                        label: '%',
                        data: data.pecentages.split(',').map((x)=>parseFloat(x)),
                        backgroundColor: data.colours.split(','),
                        borderWidth: 0
                    }
                ]
            },
            options: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: 'Alternativas mais respondidas'
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, chartData)=>{
                            const i = tooltipItem.index;
                            return `${chartData.counts[i]} | ${tooltipItem.yLabel}%`;
                        }
                    }
                }
            }
        });
    }
    $(document).off('componentLoaded:questions/question_statistics').on('componentLoaded:questions/question_statistics', (e, data)=>{
        vendorManager.ensure('chart.js', ()=>{
            const $incomePercentageChart = $('#js-income-percentage-chart', data.context);
            const $mostAnsweredAlternativesChart = $('#js-most-answered-alternatives-chart', data.context);
            incomePercentageChart($incomePercentageChart);
            mostAnsweredAlternativesChart($mostAnsweredAlternativesChart);
        });
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_right/index.scss
var question_right = __webpack_require__(59890);
;// CONCATENATED MODULE: ./pages/questions/components/question_right/index.js


// EXTERNAL MODULE: ./pages/questions/components/question_wrong/index.scss
var question_wrong = __webpack_require__(81845);
;// CONCATENATED MODULE: ./pages/questions/components/question_wrong/index.js


// EXTERNAL MODULE: ./pages/questions/components/question_statistics/blockestatistica_desktop.png
var blockestatistica_desktop = __webpack_require__(25781);
// EXTERNAL MODULE: ./pages/questions/components/question_statistics/blockestatistica_responsive.png
var blockestatistica_responsive = __webpack_require__(85814);
// EXTERNAL MODULE: ./pages/questions/components/question_statistics/exclamacao_img.png
var exclamacao_img = __webpack_require__(46117);
// EXTERNAL MODULE: ./pages/questions/components/question_statistics/index.scss
var question_statistics = __webpack_require__(95614);
;// CONCATENATED MODULE: ./pages/questions/components/question_statistics/index.js









(function($) {
    'use strict';
    $(document).on('componentLoaded:questions/question_statistics', ()=>{
        UserTracker.emit('event', {
            eventName: 'stats question clicked'
        });
        const redirect_mesa = ()=>{
            const buttonElement = document.getElementById('link_go_to_ils');
            const url = buttonElement == null ? void 0 : buttonElement.getAttribute('name');
            const question_id = buttonElement == null ? void 0 : buttonElement.getAttribute('question_id');
            const timestamp = new Date().getTime();
            let search = location.search.slice(1, location.search.length);
            if (!search) {
                search += 'my_questions=all';
            }
            const ils_complete_url = `${url}playground/questoes?statistic_question_id=${question_id}&${search}&timestamp=${timestamp}`;
            if (buttonElement) {
                buttonElement.href = ils_complete_url;
            }
        };
        redirect_mesa();
    });
})(window.jQuery);

// EXTERNAL MODULE: ./pages/questions/components/question_teacher/index.js
var question_teacher = __webpack_require__(95185);
// EXTERNAL MODULE: ./pages/questions/components/question_belt/index.scss
var question_belt = __webpack_require__(57233);
// EXTERNAL MODULE: ./components/modals/not_subscribed_user_modal/index.js
var not_subscribed_user_modal = __webpack_require__(11971);
// EXTERNAL MODULE: ./utils/study/study.js
var study = __webpack_require__(81210);
// EXTERNAL MODULE: ./utils/permissions/feedbacks.js + 10 modules
var feedbacks = __webpack_require__(49024);
// EXTERNAL MODULE: ./utils/media_query/index.js
var media_query = __webpack_require__(28925);
;// CONCATENATED MODULE: ./pages/questions/components/question_belt/index.js

















class QuestionBelt {
    static start() {
        const $component = window.jQuery('.q-question-belt');
        const $tooltips = window.jQuery('[data-toggle="tooltip"]', $component);
        if (media_query/* MediaQuery.is */.z.is('lt_sm')) {
            $tooltips.each((i, el)=>window.jQuery(el).tooltip('disable'));
        }
        const experimentQuestionBeltBlockIsActive = gon.flags.question_belt_block.visible;
        if (!experimentQuestionBeltBlockIsActive) {
            window.jQuery('#question_commented_feedback', $component).off('click.permissions').on('click.permissions', (event)=>{
                QuestionBelt.commentedFeedback(event);
            });
        }
        window.jQuery('.nav-tabs a', $component).off('shown.bs.tab').on('shown.bs.tab', (e)=>{
            if (!window.jQuery('body').data().isUserSignedIn) {
                const $link = window.jQuery(e.currentTarget);
                $link.attr('aria-expanded', false);
                $link.parent().removeClass('active');
                window.jQuery($link.attr('href')).removeClass('active');
                return;
            }
            const isShowPath = $component.data('is-show-path');
            const experimentQuestionBeltLimit = gon.flags.question_belt_limits;
            const questionBeltBlockInShow = experimentQuestionBeltLimit.QuestionBeltBlockInShow;
            const $tab = window.jQuery(e.currentTarget);
            const { disabled, componentName, hasComments } = $tab.data();
            if (questionBeltBlockInShow && isShowPath && window.currentUser.subscriptionStatus === 'standard' && [
                'question_comments',
                'question_teacher'
            ].includes(componentName)) {
                const parseComponentNameToModalStandard = {
                    question_comments: 'question_comments',
                    question_teacher: 'commented_feedback'
                };
                new not_subscribed_user_modal/* default */.Z('#js-not-subscribed-user-modal', parseComponentNameToModalStandard[componentName]);
                const restrictedResource = feedbacks/* default.utils.getEventResourceLimitSlug */.Z.utils.getEventResourceLimitSlug(componentName);
                feedbacks/* default._sendAnalytics */.Z._sendAnalytics({
                    'resouce limited': restrictedResource
                });
                return QuestionBelt.closeTab($component);
            }
            const RESOURCES_WITH_LIMITS = [
                'question_comments',
                'question_statistics'
            ];
            if (disabled) {
                if (experimentQuestionBeltBlockIsActive && RESOURCES_WITH_LIMITS.includes(componentName)) {
                    feedbacks/* default.questionBeltBlock */.Z.questionBeltBlock();
                    return QuestionBelt.closeTab($component);
                }
            }
            if (RESOURCES_WITH_LIMITS.includes(componentName)) {
                if (componentName === 'question_comments') {
                    UserTracker.emit('event', {
                        eventName: 'student commentary viewed',
                        except: [
                            'user'
                        ]
                    });
                    if (!hasComments) {
                        QuestionBelt.loadTab($tab.parents('.q-question-belt'), componentName, true);
                        return;
                    }
                }
                QuestionBelt.checkQuestionLimits(e);
                return;
            }
            QuestionBelt.loadTab($tab.parents('.q-question-belt'), componentName, true);
        });
        window.jQuery('.js-tab-close-btn', $component).off('click').on('click', (e)=>{
            const $button = window.jQuery(e.currentTarget);
            if ($button.hasClass('js-tab-close-btn-bottom')) {
                window.jQuery('html, body').animate({
                    scrollTop: $button.parents('.js-question-item').offset().top - 20
                }, 200);
            }
            QuestionBelt.closeTab($component);
            event_manager/* EventManager.publish */.Q.publish('questionBelt.tabClosed', {
                $tabPane: $button.parent('.tab-pane')
            });
        });
    }
    static closeTab($component) {
        window.jQuery('.nav-tabs .active', $component).removeClass('active');
        window.jQuery('.nav-tabs [data-toggle="tab"]', $component).attr('aria-expanded', false);
        window.jQuery('.tab-pane.active', $component).removeClass('active');
        window.jQuery('.tab-pane .js-content.js-uncachable.q-component-loaded', $component).removeClass('q-component-loaded');
    }
    static disableTab($tab) {
        const $container = window.jQuery('.js-content', $tab.attr('href'));
        const $tabs = window.jQuery('.q-question-belt-tabs', $container);
        $tab.data('aria-expanded', false);
        $tab.parent('.active').removeClass('active');
        $container.parent().removeClass('active');
        $tabs.removeClass('disabled');
    }
    static showFreemiumPaywall($tab) {
        const $container = window.jQuery('.js-content', $tab.attr('href'));
        $container.find('.q-question-tab-content').hide();
    }
    static loadTab(context, componentName, force = false, reached = false) {
        const $component = context;
        const $tab = window.jQuery(`[data-component-name="${componentName}"]`, $component);
        const $container = window.jQuery('.js-content', $tab.attr('href'));
        const $tabs = window.jQuery('.q-question-belt-tabs', $container);
        const tabData = $tab.data();
        const questionId = parseInt($component.data('question-id'));
        const productKey = $component.data('product-key');
        const productSlug = $component.data('product-slug');
        const productId = $component.data('product-id');
        const alreadySolved = $component.data('already-solved');
        const isShowPath = $component.data('is-show-path');
        const $ctaPulse = window.jQuery(`.cta-pulse.js-${questionId}-has-comments`, $component);
        if ($ctaPulse && componentName === 'question_comments') {
            $ctaPulse.addClass('hidden');
        }
        const { hasDefinitiveFeedback, urlFeedbackJustification, hasComments } = tabData;
        if (force || !$container.hasClass('q-component-loaded')) {
            const data = {
                question_id: questionId,
                product_id: productId,
                product_key: productKey,
                product_slug: productSlug,
                already_solved: alreadySolved,
                has_definitive_feedback: hasDefinitiveFeedback,
                url_feedback_justification: urlFeedbackJustification,
                show_path: isShowPath,
                limit_reached: reached,
                has_comments: hasComments
            };
            $tabs.addClass('disabled');
            ajax_component_loader/* default.load */.Z.load({
                target: $container,
                component: `questions/${tabData.componentName}`,
                type: 'page_component',
                asset_key: null,
                data: data
            }).then(()=>{
                const hasFreemiumBlockMessage = window.jQuery('.q-freemium-block-message');
                (self || window).blazyInstance.revalidate();
                event_manager/* EventManager.publish */.Q.publish('questionBelt.tabLoaded', {
                    questionId,
                    $tabPane: $container.parent('.tab-pane')
                });
                if (hasFreemiumBlockMessage.length > 0) {
                    (0,block_message/* runFreemiumBlockMessageScript */.e)();
                }
            }).catch(()=>{
                QuestionBelt.disableTab($tab);
            });
        }
    }
    static commentedFeedback(event) {
        const { proceed, reason } = window.permissions.hasPermissions([
            'account',
            'confirmed_account',
            'commented_feedback_enabled'
        ]);
        if (proceed) {
            return;
        }
        event.detail = {
            type: 'commented_feedback'
        };
        window.permissions.feedbacks[reason](event);
        if (!window.currentUser) {
            return;
        }
        UserTracker.emit('event', {
            eventName: 'professor feedback clicked'
        });
        if (reason !== 'commented_feedback_enabled') {
            UserTracker.emit('event', {
                eventName: 'account restriction reached',
                data: {
                    'resource restricted': 'commented feedback'
                }
            });
        }
    }
    static checkQuestionLimits(event) {
        const $tab = window.jQuery(event.currentTarget);
        const { componentName } = $tab.data();
        /*
     * If check_limit API returns a success response, we just load the tab and follow with the render
     * If we receive an error from API, we hide the tabs and displays the modal limit (when API return limit_reached in the response body)
     */ study/* default.track */.Z.track(componentName, ()=>{
            QuestionBelt.loadTab($tab.parents('.q-question-belt'), componentName, true);
        }, ({ response })=>{
            const shouldDisplayPaywall = response.status === 422 || window.currentUser.subscriptionStatus === 'standard';
            if (shouldDisplayPaywall) {
                feedbacks/* default.questionBeltLimit */.Z.questionBeltLimit(componentName);
            }
            QuestionBelt.loadTab($tab.parents('.q-question-belt'), componentName, true, shouldDisplayPaywall);
        });
    }
}
(function() {
    'use strict';
    window.QuestionBelt = QuestionBelt;
    window.QuestionBelt.start();
})(window.jQuery);


/***/ }),

/***/ 48942:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44632);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82114);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17448);



class QuestionCourses {
    init() {
        this.$button = window.jQuery('.button-card', this.$context);
        this.$button.on('click', ()=>{
            UserTracker.emit('event', {
                eventName: 'topic guide showcase clicked'
            });
        });
    }
    constructor($context){
        this.$context = $context;
        this.init();
    }
}
(function($1) {
    'use strict';
    $1(document).off('componentLoaded:questions/question_courses').on('componentLoaded:questions/question_courses', (e, data)=>{
        new QuestionCourses(data.context);
    });
})(window.jQuery);


/***/ })

}]);